import { getAccessToken } from './access-token.service';
import { me } from './me.service';
import { refreshToken } from './refresh-token.service';

export const authService = {
  me,
  refreshToken,
  getAccessToken,
};
